module.exports = __webpack_public_path__ + "static/media/logo_geo4d.dce97b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/logo_geo4d.jpg
// module id = 728
// module chunks = 0